module.exports = __webpack_public_path__ + "img/web3icon8.b67eef6c.png";